import { type Timezone, type TimezoneOffset } from './types.js';

export const TIMEZONE_OFFSETS: TimezoneOffset[] = [
  { id: 'OFFSET_ONE_HOUR', label: '1 Hour', offset: 1 },
  { id: 'OFFSET_TWO_HOURS', label: '2 Hours', offset: 2 },
  { id: 'OFFSET_THREE_HOUR', label: '3 Hours', offset: 3 },
  { id: 'OFFSET_FOUR_HOUR', label: '4 Hours', offset: 4 },
  { id: 'OFFSET_FIVE_HOUR', label: '5 Hours', offset: 5 },
];

export const TIMEZONES: Timezone[] = [
  {
    id: 'PST',
    label: '(GMT-8) Pacific Standard Time (PST)',
    name: 'Pacific Standard Time',
    offset: -8,
  },
  {
    id: 'EST',
    label: '(GMT-5) Eastern Standard Time (EST)',
    name: 'Eastern Standard Time',
    offset: -5,
  },
  {
    id: 'CST',
    label: '(GMT-6) Central Standard Time (CST)',
    name: 'Central Standard Time',
    offset: -6,
  },
  {
    id: 'MST',
    label: '(GMT-7) Mountain Standard Time (MST)',
    name: 'Mountain Standard Time',
    offset: -7,
  },
  {
    id: 'AKST',
    label: '(GMT-9) Alaska Standard Time (AKST)',
    name: 'Alaska Standard Time',
    offset: -9,
  },
  {
    id: 'HST',
    label: '(GMT-10) Hawaii Standard Time (HST)',
    name: 'Hawaii Standard Time',
    offset: -10,
  },
  {
    id: 'CET',
    label: '(GMT+1) Central European Time (CET)',
    name: 'Central European Time',
    offset: 1,
  },
  {
    id: 'EET',
    label: '(GMT+2) Eastern European Time (EET)',
    name: 'Eastern European Time',
    offset: 2,
  },
  {
    id: 'GMT',
    label: '(GMT-0) Greenwich Mean Time (GMT)',
    name: 'Greenwich Mean Time',
    offset: 0,
  },
  {
    id: 'MSK',
    label: '(GMT+3) Moscow Time (MSK)',
    name: 'Moscow Time',
    offset: 3,
  },
  {
    id: 'AMT',
    label: '(GMT+4) Armenia Time (AMT)',
    name: 'Armenia Time',
    offset: 4,
  },
  {
    id: 'PKT',
    label: '(GMT+5) Pakistan Standard Time (PKT)',
    name: 'Pakistan Standard Time',
    offset: 5,
  },
  {
    id: 'OMSK',
    label: '(GMT+6) Omsk Time (OMSK)',
    name: 'Omsk Time',
    offset: 6,
  },
  {
    id: 'KRAT',
    // cspell:disable-next-line
    label: '(GMT+7) Kranoyask Time (KRAT)',
    // cspell:disable-next-line
    name: 'Kranoyask Time',
    offset: 7,
  },
  {
    id: 'CST',
    label: '(GMT+8) China Standard Time (CST)',
    name: 'China Standard Time',
    offset: 8,
  },
  {
    id: 'JST',
    label: '(GMT+9) Japan Standard Time (JST)',
    name: 'Japan Standard Time',
    offset: 9,
  },
  {
    id: 'AEST',
    label: '(GMT+10) Eastern Australia Standard Time (AEST)',
    name: 'Eastern Australia Standard Time',
    offset: 10,
  },
  {
    id: 'SAKT',
    label: '(GMT+11) Sakhalin Time (SAKT)',
    name: 'Sakhalin Time',
    offset: 11,
  },
  {
    id: 'NZST',
    label: '(GMT+12) New Zealand Standard Time (NZST)',
    name: 'New Zealand Standard Time',
    offset: 12,
  },
  {
    id: 'WAT',
    label: '(GMT-1) West Africa Time (WAT)',
    name: 'West Africa Time',
    offset: -1,
  },
  {
    id: 'AT',
    label: '(GMT-2) Azores Time (AT)',
    name: 'Azores Time',
    offset: -2,
  },
  {
    id: 'ART',
    label: '(GMT-3) Argentina Time (ART)',
    name: 'Argentina Time',
    offset: -3,
  },
  {
    id: 'AST',
    label: '(GMT-4) Atlantic Standard Time (AST)',
    name: 'Atlantic Standard Time',
    offset: -4,
  },
  {
    id: 'NT',
    label: '(GMT-11) Nome Time (NT)',
    name: 'Nome Time',
    offset: -11,
  },
  {
    id: 'IDLW',
    label: '(GMT-12) International Date Line West (IDLW)',
    name: 'International Date Line West',
    offset: -12,
  },
];

export const MAX_OFFSET = 5;
export const MAX_TIMEZONE = 12;
export const MIN_TIMEZONE = -12;
